import { EntityWidget } from "./EntityWidget";
import { WallEntityController } from "../WallEntityController";
import { Wall } from "@rhinov/savane-js";

export class WallEntityWidget extends EntityWidget {

    declare entity: Wall;
    declare controller: WallEntityController;

    handleImageListEvent = (event: MouseEvent) => {
        var elem = event.currentTarget as HTMLInputElement & { param?: any }
        if (event.ctrlKey) {
            this.controller.openAssetDetail(elem.param);
            return;
        }
        if (!event.ctrlKey && event.button === 0) {
           
            var index = 0;
            this.controller.allModelsForCurrentDecoratedWall.forEach((modele: any) => {
                let element = document.getElementById(`WallModel-${index}`);
                if (element) {
                    element.classList.remove('active');
                }
                index++;
            })
            elem.classList.add('active');
            this.controller.updateWallModeleType(elem.param);
            let preview = document.getElementById('previewWall')
            if (preview && preview.getElementsByTagName("img")[0]) {
                preview.getElementsByTagName("img")[0].src = this.controller.itemPreview ?? '';
            }
        }
    }

    constructor(entity: Wall, panel: any, deliverable: any, openAssetDetailCallback: CallableFunction) {
        super(entity, panel, deliverable, openAssetDetailCallback);
        this.controller = new WallEntityController(entity,panel, deliverable, openAssetDetailCallback);
        this.propertiesTab = ['plusLess', 'plusLess', 'staticCm', 'tripleToggle', 'tripleToggle', 'buttonToggle', 'buttonToggle', 'buttonToggle', 'buttonToggle',
            'slopeToggle', 'buttonToggle', 'previewWall', 'selectWallModel'];
        this.controller.propertiesTab = this.propertiesTab;
    }

    slopeToggle(property: any): string {
        return `
            <!-- slope toggle FIXME Why not using generic toggle -->
            <div class="property-item padding ${property.key}">
                <div class="form${property.key} togglebutton">
                    <label class="horizontal-toggle">
                        <div style="padding-right: 10px">${property.title}</div>
                        <input type="checkbox" id="buttonToggle-${property.key}"
                            class="togglebutton${property.key}">
                        <span class="toggle "></span>
                    </label>
                </div>
                <!-- Slope start height -->
                <div id="${property.key}Height" class="nopadding ${property.key}Height">
                    <div style="padding-top:15px"
                        class=" add-remove label-floating form${property.key}Height ">
                        <div style="width:90px;padding:0px">
                            <div class="input-wrapper">
                                <input id="boxHeight-${property.key}" onClick="this.select();"
                                    class="inputEnterValited input${property.key}Height form-control" type="number"
                                    step=${property.step}>
                            </div>
                            <h>
                                Hauteur/sol sous-pente
                            </h>
                            <div class="clearfix"></div>
                        </div>
                        <div class="cm-display" style="float:left">
                            <h> cm </h>
                        </div>
                        <div class="add-remove-buttons  ">
                            <div id="lessHeight-${property.key}" class="btn btn-flat btn-default  min less" data-type=${property.key}Height>
                                <i style="font-size:14px;">-</i>
                            </div>
                            <div id="plusHeight-${property.key}" class="btn btn-flat btn-default  max more" data-type=${property.key}Height>
                                <i style="font-size:10px;font-weight:900;"
                                    class="material-icons icon-FloatBar_Plus"></i>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>
                <!-- Slope length 1 direct side -->
                <div id="${property.key}Length1" class="nopadding ${property.key}Length1">
                    <div style="padding-top:15px"
                        class=" add-remove label-floating form${property.key}Length1 ">
                        <div style="width:90px;padding:0px">
                            <div class="input-wrapper">
                                <input id="boxLength1-${property.key}" onClick="this.select();"
                                    class="inputEnterValited input${property.key}Length1 form-control"
                                    type="number" step=${property.step}>
                            </div>
                            <h>
                                Largeur à droite
                            </h>
                            <div class="clearfix"></div>
                        </div>
                        <div class="cm-display" style="float:left">
                            <h> cm </h>
                        </div>
                        <div class="add-remove-buttons  ">
                            <div id="lessLength1-${property.key}" class="btn btn-flat btn-default  min less"
                                data-type=${property.key}Length1>
                                <i style="font-size:14px;">-</i>
                            </div>
                            <div id="plusLength1-${property.key}"class="btn btn-flat btn-default  max more"
                                data-type=${property.key}Length1>
                                <i style="font-size:10px;font-weight:900;"
                                    class="material-icons icon-FloatBar_Plus"></i>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>
                <!-- Slope length 2 undirect side -->
                <div id="${property.key}Length2" class="nopadding ${property.key}Length2">
                    <div style="padding-top:15px"
                        class=" add-remove label-floating form${property.key}Length2 ">
                        <div style="width:90px;padding:0px">
                            <div class="input-wrapper">
                                <input id="boxLength2-${property.key}" onClick="this.select();"
                                    class="inputEnterValited input${property.key}Length2 form-control"
                                    type="number" step=${property.step}>
                            </div>
                            <h>
                                Largeur à gauche
                            </h>
                            <div class="clearfix"></div>
                        </div>
                        <div class="cm-display" style="float:left">
                            <h> cm </h>
                        </div>
                        <div class="add-remove-buttons">
                            <div id="lessLength2-${property.key}" class="btn btn-flat btn-default  min less"
                                data-type=${property.key}Length2>
                                <i style="font-size:14px;">-</i>
                            </div>
                            <div id="plusLength2-${property.key}" class="btn btn-flat btn-default  max more"
                                data-type=${property.key}Length2>
                                <i style="font-size:10px;font-weight:900;"
                                    class="material-icons icon-FloatBar_Plus"></i>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
        `;
    }

    setslopeToggleListener(property: any) {
        this.setbuttonToggleListener(property);
        this.setplusLessListener(property, "Height");
        this.setplusLessListener(property, "Length1");
        this.setplusLessListener(property, "Length2");
    }

    removeslopeToggleListener(property: any) {
        this.removebuttonToggleListener(property);
        this.removeplusLessListener(property, "Height");
        this.removeplusLessListener(property, "Length1");
        this.removeplusLessListener(property, "Length2");
    }
    
    handleWallModels(): string {
        var html = "";
        var index = 0;
        this.controller.allModelsForCurrentDecoratedWall.forEach((modele: any) => {
            html += `
                <img id="WallModel-${index}" style="display: inline-block;width:180px;height:180px;vertical-align:text-bottom"
                    title="${modele.name}"
                    src="${this.controller.getWallPreviewUrl(modele)}"
                    class="${this.controller.isWallModelSelected(modele) ? "active" : ""}"></li>
            `;
            index++;
        })
        return html;
    }

    selectWallModel(property: any): string {
        return `
            <!--Select model for special walls-->
            <div id="wallContainer" class="property-item padding wallModel tulipImage">
                <h style="font-weight:600;">
                    ${property.title}
                </h>
                <div id="wallList" style="margin-bottom:10px;padding:0;width:382px;max-height:650px;overflow-y:auto">
                    ${this.handleWallModels()}
                </div>
            </div>
        `;
    }

    setselectWallModelListener() {
        var index = 0;
        this.controller.allModelsForCurrentDecoratedWall.forEach((modele: any) => {
            let element = document.getElementById(`WallModel-${index}`) as HTMLInputElement & { param?: any };
            if (element) {
                element.param = modele;
                element.addEventListener('mousedown', this.handleImageListEvent);
            }
            index++;
        })
    }

    removeselectWallModelListener() {
        var index = 0;
        this.controller.allModelsForCurrentDecoratedWall.forEach((modele: any) => {
            let element = document.getElementById(`WallModel-${index}`);
            if (element) {
                element.removeEventListener('mousedown', this.handleImageListEvent);
            }
            index++;
        })
    }


    previewWall(property: any): string {
        return `
            <!-- PREVIEW -->
            <div id="previewWall" class="property-item padding wallPreview tulipImage">
                <h style="font-weight:600;">
                    ${property.title}
                </h>
                <div>
                    <img style="width:180px;height:180px;" src="${this.controller.itemPreview}" />
                </div>
            </div>
        `;
    }

    setpreviewWallListener() {
        let preview = document.getElementById('previewWall');
        if (preview) {
            preview.addEventListener('mousedown', this.previewDetails)
        }
    }

    removepreviewWallListener() {
        let preview = document.getElementById('previewWall');
        if (preview) {
            preview.removeEventListener('mousedown', this.previewDetails)
        }
    }

    html(): string {
        var i;
        var html = super.nameHeader() + super.propertyStart();
        for (i = 0; i < this.propertiesTab.length; i++) {
            html += (this as any)[this.propertiesTab[i]](this.panel.properties[i]);
        }
        html += super.propertyEnd();
        return html;
    }
}